<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 20 20"
    width="20"
    height="20"
  >
    <g transform="translate(0, 0)">
      <defs>
        <path
          id="path-161006391932927832"
          d="M10 0 C15.519150244940002 0 20 4.48084975506 20 10 C20 15.519150244940002 15.519150244940002 20 10 20 C4.48084975506 20 0 15.519150244940002 0 10 C0 4.48084975506 4.48084975506 0 10 0 Z"
          vector-effect="non-scaling-stroke"
        />
      </defs>
      <g transform="translate(0, 0)">
        <path
          d="M10 0 C15.519150244940002 0 20 4.48084975506 20 10 C20 15.519150244940002 15.519150244940002 20 10 20 C4.48084975506 20 0 15.519150244940002 0 10 C0 4.48084975506 4.48084975506 0 10 0 Z"
          style="
            stroke: rgb(140, 140, 140);
            stroke-width: 0px;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            fill: rgb(217, 90, 75);
          "
          vector-effect="non-scaling-stroke"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
    name: 'RedDotIcon'
}
</script>